import React from 'react';
import { FormFieldRadio } from '@publishing-engine/domain/types/article';
import { Box, Flex, Text } from '@chakra-ui/react';
import { RadioGroup } from '../RadioGroup.js';
import { useFormContext } from 'react-hook-form';
import { FormFeedback } from '@morressier/alembic';

interface FormFieldRadioProps {
  config: FormFieldRadio;
  textStyle?: string;
}

export const Recommendation: React.FC<FormFieldRadioProps> = ({
  config,
  textStyle
}) => {
  const {
    formState: { errors },
    control
  } = useFormContext();
  const {
    params: { labels, validations },
    caseDataFields: { main: field }
  } = config;

  const options = validations.options.map(key => {
    return {
      value: key,
      children: (
        <Flex flexDirection="column">
          <Text textStyle="headingItem">{labels.options[key]?.main}</Text>
          <Text textStyle="textBody">{labels.options[key]?.secondary}</Text>
        </Flex>
      )
    };
  });

  const error = errors[field];

  return (
    <Flex flexDirection="column" gap={6}>
      <Flex flexDirection="column">
        <Flex alignItems="center" gap={2}>
          <Text textStyle={textStyle}>
            {labels.main}
            {validations.required && (
              <Box
                as="span"
                color="actionSecondaryCautionContent"
                textStyle={textStyle}
              >
                *
              </Box>
            )}
          </Text>
        </Flex>
        <Text textStyle="textBody">{labels.subtitle}</Text>
      </Flex>
      <Flex flexDirection="column">
        <RadioGroup
          name={field}
          control={control}
          options={options}
          required={validations.required}
          gap={2}
        />
      </Flex>
      {error && (
        <FormFeedback variant="error">
          {error.type === 'required'
            ? 'This field is required'
            : `Please select a valid ${labels.main} option`}
        </FormFeedback>
      )}
    </Flex>
  );
};
